/* ═══ HESTIA — JS global ═══ */

document.addEventListener('DOMContentLoaded', function () {

  /* ── Navbar scroll ── */
  const navbar = document.getElementById('navbar');
  if (navbar) {
    window.addEventListener('scroll', () => {
      navbar.classList.toggle('scrolled', window.scrollY > 20);
    });
  }

  /* ── Menu drawer ── */
  const hamburgerBtn = document.getElementById('hamburgerBtn');
  const menuDrawer   = document.getElementById('menuDrawer');
  const menuOverlay  = document.getElementById('menuOverlay');
  const menuClose    = document.getElementById('menuClose');

  function openMenu() {
    menuDrawer.classList.add('open');
    menuOverlay.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeMenu() {
    menuDrawer.classList.remove('open');
    menuOverlay.classList.remove('open');
    document.body.style.overflow = '';
  }
  if (hamburgerBtn && menuDrawer) {
    hamburgerBtn.addEventListener('click', openMenu);
    hamburgerBtn.addEventListener('keydown', e => { if (e.key === 'Enter') openMenu(); });
    menuClose.addEventListener('click', closeMenu);
    menuOverlay.addEventListener('click', closeMenu);
  }

  /* ── Popup newsletter (délai configurable) ── */
  const popupOverlay = document.getElementById('popupOverlay');
  if (popupOverlay) {
    const delay = parseInt(popupOverlay.dataset.delay || '10', 10) * 1000;
    const popupClose = document.getElementById('popupClose');

    if (!sessionStorage.getItem('hestia_popup_seen')) {
      setTimeout(() => {
        popupOverlay.classList.add('visible');
      }, delay);
    }

    function closePopup() {
      popupOverlay.classList.remove('visible');
      sessionStorage.setItem('hestia_popup_seen', '1');
    }
    popupClose.addEventListener('click', closePopup);
    popupOverlay.addEventListener('click', e => {
      if (e.target === popupOverlay) closePopup();
    });
  }

  /* ── Fade-in au scroll ── */
  const fadeEls = document.querySelectorAll('.fade-in');
  if (fadeEls.length) {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });
    fadeEls.forEach(el => observer.observe(el));
  }

  /* ── Accordéons ── */
  document.querySelectorAll('.accordion-head').forEach(head => {
    head.addEventListener('click', () => {
      head.parentElement.classList.toggle('open');
    });
  });

  /* ── Quantité produit (fiche produit) ── */
  document.querySelectorAll('[data-qty-wrap]').forEach(wrap => {
    const input = wrap.querySelector('input[name="quantity"]');
    const minus = wrap.querySelector('[data-qty-minus]');
    const plus  = wrap.querySelector('[data-qty-plus]');
    if (!input) return;
    minus && minus.addEventListener('click', () => {
      const v = Math.max(1, parseInt(input.value || '1') - 1);
      input.value = v;
    });
    plus && plus.addEventListener('click', () => {
      input.value = parseInt(input.value || '1') + 1;
    });
  });

  /* ── Panier : changement de quantité / suppression via AJAX ── */
  document.querySelectorAll('[data-cart-change]').forEach(btn => {
    btn.addEventListener('click', () => {
      const line = btn.dataset.line;
      const qty  = parseInt(btn.dataset.qty, 10);
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: qty })
      }).then(() => window.location.reload());
    });
  });
// ── OVERLAY RECHERCHE ──
  var searchToggle = document.getElementById('searchToggle');
  var searchOverlay = document.getElementById('searchOverlay');
  var searchClose = document.getElementById('searchClose');
  if (searchToggle && searchOverlay) {
    var backdrop = document.createElement('div');
    backdrop.className = 'search-backdrop';
    document.body.appendChild(backdrop);
    var input = searchOverlay.querySelector('.search-overlay-input');
    function openSearch() {
      searchOverlay.classList.add('open');
      backdrop.classList.add('open');
      setTimeout(function(){ if(input) input.focus(); }, 100);
    }
    function closeSearch() {
      searchOverlay.classList.remove('open');
      backdrop.classList.remove('open');
    }
    searchToggle.addEventListener('click', openSearch);
    if (searchClose) searchClose.addEventListener('click', closeSearch);
    backdrop.addEventListener('click', closeSearch);
    document.addEventListener('keydown', function(e){ if(e.key === 'Escape') closeSearch(); });
  }
});
